import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { goToPage } from '@epi-actions/navigation';
import { selectGoToPageLink } from '@epi-selectors/benefitGroupSettings';
import { benefitGroupSettingsActions } from '@epi-store/benefitGroupSettings/benefitGroupSettings.slice';

export const useOrderSummaryCancel = () => {
  const [isOpenLeave, setIsOpenLeave] = useState(false);

  const goToPageLink = useSelector(selectGoToPageLink);
  const dispatch = useDispatch();

  const handleCloseLeaveModal = () => {
    dispatch(benefitGroupSettingsActions.setGoToPageLink(''));
    setIsOpenLeave(false);
  };

  const handleGoTo = () => {
    dispatch(benefitGroupSettingsActions.setGoToPageLink(''));
    dispatch(benefitGroupSettingsActions.stopOrderProcess());
    dispatch(goToPage(goToPageLink));
  };

  useEffect(() => {
    if (goToPageLink) {
      setIsOpenLeave(true);
    }
  }, [goToPageLink]);
  return {
    handleCloseLeaveModal,
    handleGoTo,
    isOpenLeave
  };
};
